import React from 'react';
import { useFeatureFlags } from '../../../../../../../../contexts/FeatureFlagContext';
import { SchedulingIntegrationModalContent } from './SchedulingIntegrationModalContent';

interface PropTypes {
  isSchedulingLoading: boolean;
  setIsSchedulingModalOpen: (isOpen: boolean) => void;
  isSchedulingModalOpen: boolean;
}

export function DisconnectedSchedulingIntegrationModal(props: PropTypes) {
  const { atsUpdateSchedulingUserIntegrationUserInfoEnabled } =
    useFeatureFlags();

  return (
    <>
      {atsUpdateSchedulingUserIntegrationUserInfoEnabled &&
        props.isSchedulingModalOpen && (
          <SchedulingIntegrationModalContent
            setIsSchedulingModalOpen={props.setIsSchedulingModalOpen}
            isSchedulingModalOpen={props.isSchedulingModalOpen}
          />
        )}
    </>
  );
}
